var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { CompaniesClient, ComponentModel, ComponentTypeEnum, CreateSystemCommand, CreateSystemCommandModel, GetComponentBySerialNumberQuery, GetComponentBySerialNumberResultEnum, GetComponentBySerialNumberResultModel, GetSiteListQuery, LookupsClient, Model, RegistrationKeyRequestModel, RequestRegistrationKeyCommand, SitesClient, SystemComponentModel, SystemComponentsClient, SystemModel, SystemsClient, UpdateSystemCommand, ModelsClient, ManufacturersClient, SystemCategoriesClient, GetSystemCategoryListQuery, UploadSystemAttachmentsCommand, SystemAttachmentsModel, ManufacturerTypeEnum } from "@/app/api/battery-portal-api";
import "@/app/component-hooks";
import RouteNames from "@/app/router/routes";
import { LoginState } from "@/app/store/modules/login.state";
import { ArrayHelper } from "@/app/utils/array-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import SystemConfigurationVue from "@/app/vues/company/system-configuration.vue";
import SystemManagementVue from "@/app/vues/company/system-management.vue";
import SystemAttachmentsVue from "@/app/vues/company/system-attachments.vue";
import { Alert } from "@/common/utils/alert";
import { Notifier } from "@/common/utils/notifier";
import { Component, Vue, Watch, Ref } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import store from "@/app/store/store";
const systemClient = new SystemsClient(window.apiUrl);
const systemComponentClient = new SystemComponentsClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const modelClient = new ModelsClient(window.apiUrl);
const manufacturerClient = new ManufacturersClient(window.apiUrl);
const systemCategoriesClient = new SystemCategoriesClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
let SystemV2Vue = class SystemV2Vue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.systemId = 0;
        this.loaded = false;
        this.working = false;
        this.requestingMonitorReplacement = false;
        this.loadingStrings = false;
        this.attemptedSave = false;
        this.hasSerialNumber = false;
        this.isSerialNumberValid = true;
        this.activeTab = 0;
        this.systemConfigurationComponentKey = 1;
        // components
        this.msg = new Alert();
        this.serialNumberMsg = new Alert();
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig();
        // models
        this.system = new SystemModel();
        this.serialNumberLookupResult = new GetComponentBySerialNumberResultModel();
        // arrays
        this.companies = [];
        this.manufacturers = [];
        this.systemCategories = [];
        this.sites = [];
        this.batteryTypes = [];
        this.lithiumBatteryTypes = [];
        this.siteOptions = [];
        this.models = [];
        this.systemAttachmentsList = null;
    }
    created() {
        this.systemId = parseInt(this.$route.params.id) || 0;
        const tabIndex = this.visibleTabs.findIndex(tab => tab === this.$route.hash);
        this.activeTab = tabIndex >= 0 ? tabIndex : 0;
        this.get();
        this.getLookups();
    }
    ;
    // get
    get() {
        if (this.isNewSystem) {
            let system = new SystemModel();
            system.init({});
            this.map(system);
            return;
        }
        systemClient
            .get(this.systemId)
            .then(response => {
            if (!response) {
                this.$router.push({ name: RouteNames.Home });
                return;
            }
            this.map(response);
            this.setValues({
                systemName: this.system.systemName,
                companyId: this.company,
                siteId: this.site,
                batteryTypeId: this.batteryType,
                systemOfflineTimeout: this.system.systemOfflineTimeout
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getLookups() {
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                this.companies = [{ value: null, text: TextHelper.emptyListItemName }].concat((response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                }));
                if (this.system.companyId) {
                    this.setFieldValue("companyId", this.company);
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                let companyId = parseInt(this.$route.params.companyId) || 0;
                if (!companyId || !this.isNewSystem)
                    return;
                let idx = ArrayHelper.findFirstIndex(this.companies, (item) => {
                    return companyId == item.value;
                });
                if (idx < 0)
                    return;
                this.system.companyId = companyId;
                this.setFieldValue("companyId", this.company);
            }),
            lookupsClient
                .getBatteryTypes()
                .then(response => {
                this.batteryTypes = response.map((item) => {
                    return {
                        value: item.key,
                        text: item.value
                    };
                });
                if (this.system.batteryTypeId) {
                    this.setFieldValue("batteryTypeId", this.batteryType);
                }
            }),
            lookupsClient
                .getLithiumBatteryTypes()
                .then(response => {
                this.lithiumBatteryTypes = response.map((item) => {
                    return {
                        value: item.key,
                        text: item.value
                    };
                });
            })
        ];
        if (this.system.companyId)
            promises.push(this.getManufacturersAndModels());
        Promise.all(promises);
    }
    ;
    getManufacturersAndModels() {
        return [
            lookupsClient
                .getManufacturers(this.system.companyId)
                .then(response => {
                this.manufacturers = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            lookupsClient
                .getModels(this.system.companyId)
                .then(response => {
                this.models = response;
            })
        ];
    }
    ;
    getCompanyLookups() {
        let companyId = this.system.companyId;
        if (!companyId) {
            this.sites = new Array();
            this.siteOptions = new Array();
            return;
        }
        ;
        let query = new GetSiteListQuery({ companyId: companyId, includeDeleted: false });
        siteClient
            .getListPOST(query)
            .then(response => {
            this.siteOptions = response;
            this.sites = [{ value: null, text: TextHelper.emptyListItemName }].concat((response || []).map((item) => {
                return {
                    value: item.siteId,
                    text: item.siteName || ""
                };
            }));
            if (this.sites.findIndex(item => item.value == this.siteId) <= -1)
                this.system.siteId = 0;
            if (this.system.siteId) {
                this.setFieldValue("siteId", this.site);
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
        let queryCategory = new GetSystemCategoryListQuery({ companyId: companyId, includeDeleted: false });
        systemCategoriesClient
            .getListPOST(queryCategory)
            .then(response => {
            this.systemCategories = [{ value: null, text: "No category" }].concat((response || []).map((item) => {
                return {
                    value: item.id,
                    text: item.name || ""
                };
            }));
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
        this.getManufacturersAndModels();
    }
    ;
    onUpsManufacturerChanged(newVal, oldVal) {
        if (newVal && oldVal && newVal.value != oldVal.value) {
            this.system.manufacturerName = (newVal === null || newVal === void 0 ? void 0 : newVal.text) != this.selectPlaceholder ? (newVal === null || newVal === void 0 ? void 0 : newVal.text) || null : null;
            this.system.modelId = null;
            this.setFieldValue("modelId", null);
        }
    }
    ;
    findSerialNumber() {
        var _a, _b, _c, _d, _e;
        if (this.working)
            return;
        this.serialNumberMsg.clear();
        let serialNumber = (_c = (_b = (_a = this.system) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.component) === null || _c === void 0 ? void 0 : _c.serialNumber;
        let componentId = (_e = (_d = this.system) === null || _d === void 0 ? void 0 : _d.controller) === null || _e === void 0 ? void 0 : _e.componentId;
        if (!serialNumber) {
            Notifier.onError(`Please enter a serial number`);
            return;
        }
        let query = new GetComponentBySerialNumberQuery({
            serialNumber: serialNumber,
            componentId: componentId
        });
        this.isSerialNumberValid = false;
        systemComponentClient
            .getComponentBySerialNumber(query)
            .then(response => {
            this.serialNumberLookupResult = response;
            this.isSerialNumberValid = response.result != GetComponentBySerialNumberResultEnum.AssignedToAnotherSystem;
            if (!this.isNewSystem && !response.canBeAssignedToExistingSystem)
                this.isSerialNumberValid = false;
            switch (response.result) {
                case GetComponentBySerialNumberResultEnum.NotFound:
                    this.serialNumberMsg.info(`Not found`);
                    break;
                case GetComponentBySerialNumberResultEnum.AssignedToCurrentSystem:
                    this.serialNumberMsg.success(`Found`);
                    break;
                case GetComponentBySerialNumberResultEnum.AssignedToPlaceholderSystem:
                    if (this.isNewSystem)
                        this.serialNumberMsg.success(`Found`);
                    else
                        this.serialNumberMsg.error(`Found, but assigned to another system.`);
                    break;
                case GetComponentBySerialNumberResultEnum.AssignedToAnotherSystem:
                    this.serialNumberMsg.error(`Found, but assigned to another system.`);
                    break;
            }
            if (this.isSerialNumberValid)
                if (this.serialNumberMsg.variant == "primary")
                    Notifier.onWarning(this.serialNumberMsg.message);
                else
                    Notifier.onOk(this.serialNumberMsg.message);
            else
                Notifier.onError(this.serialNumberMsg.message);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.isSerialNumberValid = true;
        });
    }
    ;
    reloadSystemDetails(item = null) {
        if ((item === null || item === void 0 ? void 0 : item.componentTypeId) == ComponentTypeEnum.Controller) {
            this.get();
        }
        if (this.systemManagement)
            this.systemManagement.getComponentTree();
    }
    ;
    // set
    save() {
        if (this.working)
            return;
        if (!this.companyId) {
            Notifier.onError("Please select a company.");
            return;
        }
        ;
        if (!this.siteId) {
            Notifier.onError("Please select an installation site.");
            return;
        }
        ;
        if (!this.isSerialNumberValid) {
            Notifier.onError("Please check the serial number.");
            return;
        }
        const handleSubmitAction = this.handleSubmit(() => {
            var _a;
            this.working = true;
            let system = this.system;
            let site = this.siteOptions.filter(site => site.siteId == this.siteId)[0];
            if (site)
                system.site = site;
            system.whenInstalled = system.whenInstalled ? DateHelper.convertToDate(system.whenInstalled.toString()) : null;
            system.whenManufactured = system.whenManufactured ? DateHelper.convertToDate(system.whenManufactured.toString()) : null;
            // Set UPS/Charger manufacturer name
            let upsManufacturer = this.upsManufacturer;
            if (upsManufacturer && upsManufacturer.text != this.selectPlaceholder)
                system.manufacturerName = upsManufacturer.text;
            // Set UPS/Charger model name
            let upsModel = this.upsModel;
            if (upsModel && upsModel.text != this.selectPlaceholder)
                system.modelName = upsModel.modelName;
            if ((_a = system.controller) === null || _a === void 0 ? void 0 : _a.component) {
                system.controller.component.whenManufactured = system.controller.component.whenManufactured ? DateHelper.convertToDate(system.controller.component.whenManufactured.toString()) : null;
                let controllerModel = this.controllerModel;
                if (controllerModel)
                    system.controller.component.modelName = controllerModel.modelName;
            }
            let promise = () => {
                return this.isNewSystem
                    ? systemClient.add(new CreateSystemCommand({ requestModel: new CreateSystemCommandModel({ system: system, createController: true }) }))
                    : systemClient.update(system.systemId, new UpdateSystemCommand({ requestModel: system }));
            };
            promise()
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                this.systemId = response;
                // Save attachments only if they have been loaded (not null)
                if (this.systemAttachmentsList !== null) {
                    try {
                        var attachmentsModel = new SystemAttachmentsModel();
                        attachmentsModel.systemId = this.systemId;
                        attachmentsModel.attachments = this.systemAttachmentsList;
                        yield systemClient.uploadSystemAttachments(new UploadSystemAttachmentsCommand({ requestModel: attachmentsModel }));
                    }
                    catch (attachmentEx) {
                        Notifier.onWarning('System saved but attachments could not be uploaded.');
                        console.error('Attachment upload failed:', attachmentEx);
                    }
                }
                if (!this.isNewSystem)
                    this.systemConfigurationComponentKey++;
                this.get();
                this.getCompanyLookups();
                this.reloadSystemDetails();
                // Reload attachments immediately to ensure the list is up to date
                if (this.systemAttachments) {
                    this.systemAttachments.reload(true);
                }
                Notifier.onOk();
            }))
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                // re-load manufacturers and models in case any had been added
                this.getManufacturersAndModels();
            });
        }, (ctx) => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    archive() {
        if (this.working || this.isNewSystem)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this system?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            systemClient
                .delete(this.system.systemId)
                .then(() => {
                this.system.whenDeleted = new Date();
                Notifier.onOk(`System # ${this.system.systemId} has been successfully archived.`);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore() {
        if (this.working || this.isNewSystem)
            return;
        this.working = true;
        systemClient
            .restore(this.system.systemId)
            .then(() => {
            this.system.whenDeleted = undefined;
            Notifier.onOk(`System # ${this.system.systemId} has been successfully restored.`);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    /** Request a new monitor replacement key */
    requestMonitorReplacement() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (!((_b = (_a = this.system) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.component)) {
                Notifier.onWarning(`This system does not have a controller. Unable to request monitor replacement.`);
                return;
            }
            ;
            // clear previously assigned replacement key.
            this.system.controller.replacementRegistrationKey = null;
            if (this.working)
                return;
            this.working = true;
            this.requestingMonitorReplacement = true;
            let request = new RegistrationKeyRequestModel();
            request.componentId = this.system.controller.componentId;
            request.systemId = this.system.controller.systemId;
            let command = new RequestRegistrationKeyCommand();
            command.requestModel = request;
            return yield systemComponentClient
                .requestRegistrationKey(command)
                .then(response => {
                this.downloadRegistrationKeyFile(response);
                if (!this.system.controller)
                    return;
                this.system.controller.replacementRegistrationKey = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.requestingMonitorReplacement = false;
            });
        });
    }
    ;
    /** Download an existing pending monitor replacement key */
    getMonitorReplacementKey() {
        var _a, _b;
        if (!((_b = (_a = this.system) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.replacementRegistrationKey))
            return;
        this.downloadRegistrationKeyFile(this.system.controller.replacementRegistrationKey);
    }
    ;
    goBack() {
        this.$router.back();
    }
    ;
    map(system) {
        this.system = system;
        let controller = system.controller;
        if (!controller || !controller.component) {
            controller = new SystemComponentModel();
            controller.init({});
            let component = new ComponentModel();
            component.init({});
            controller.component = component;
            this.system.controller = controller;
        }
        else {
            this.hasSerialNumber = controller.component.serialNumber ? true : false;
        }
        this.loaded = true;
    }
    ;
    /**
     * Add new manufacturer to manufacturers array.
     */
    addUpsManufacturer(option) {
        if (!option)
            return;
        if (option == this.selectPlaceholder)
            return;
        let match = this.manufacturers.filter(item => item.manufacturerId == 0)[0];
        if (match) {
            match.manufacturerName = option;
            return;
        }
        let manufacturer = {
            companyId: this.system.companyId,
            manufacturerId: 0,
            manufacturerTypeId: ManufacturerTypeEnum.ChargerUPS,
            manufacturerName: `${option}`.trim()
        };
        this.manufacturers.push(manufacturer);
        this.upsManufacturer = this.chargerUpsManufacturers.filter(item => item.value == 0)[0];
    }
    ;
    deleteManufacturer(manufacturer) {
        this.$confirmModal.show(`Are you sure you want to remove the manufacturer ${manufacturer.text}`, { title: "Please Confirm" })
            .then((value) => {
            if (!value)
                return;
            // If it is a recently model added, just remove from the list
            if (manufacturer.value == 0) {
                this.manufacturers = this.manufacturers.filter(x => x.manufacturerId != manufacturer.value);
                Notifier.onOk('Manufacturer removed from the list!');
                return;
            }
            manufacturerClient
                .delete(manufacturer.value)
                .then(response => {
                if (response) {
                    this.manufacturers = this.manufacturers.filter(x => x.manufacturerTypeId != manufacturer.value);
                    Notifier.onOk('Manufacturer removed from the list!');
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            });
        });
    }
    addStringManufacturer(option, setManufaturer) {
        if (!option)
            return;
        if (option == this.selectPlaceholder)
            return;
        let match = this.manufacturers.filter(item => item.manufacturerId == 0)[0];
        if (match) {
            match.manufacturerName = option;
            setManufaturer(match);
            return;
        }
        let manufacturer = {
            companyId: this.system.companyId,
            manufacturerId: 0,
            manufacturerTypeId: ManufacturerTypeEnum.Battery,
            manufacturerName: `${option}`.trim(),
        };
        this.manufacturers.push(manufacturer);
        if (setManufaturer)
            setManufaturer(manufacturer);
    }
    ;
    /**
     * Add new UPS/Charger model to models array.
     */
    addUpsModel(option) {
        if (!option)
            return;
        let manufacturerId = this.system.manufacturerId;
        if (!manufacturerId && manufacturerId != 0) {
            Notifier.onWarning("Please select a Charger/UPS manufacturer first.");
            return;
        }
        let match = this.models.filter(item => item.modelId == 0 && item.manufacturerId == manufacturerId)[0];
        if (match) {
            match.modelName = option;
            match.manufacturerId = manufacturerId;
            return;
        }
        let model = new Model();
        model.modelId = 0;
        model.manufacturerId = manufacturerId;
        model.componentTypeId = ComponentTypeEnum.Controller;
        model.modelName = option;
        this.models.push(model);
        this.upsModel = model;
    }
    ;
    deleteUpsModel(model) {
        this.$confirmModal.show(`Are you sure you want to remove the model ${model.modelName}`, { title: "Please Confirm" })
            .then((value) => {
            if (!value)
                return;
            // If it is a recently added model, just remove from the list
            if (model.modelId == 0) {
                this.models = this.models.filter(x => x.modelId !== 0);
                Notifier.onOk('Model removed from the list!');
                return;
            }
            modelClient
                .delete(model.modelId)
                .then(response => {
                if (response) {
                    this.models = this.models.filter(x => x.modelId != model.modelId);
                    Notifier.onOk('Model removed from the list!');
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            });
        });
    }
    /**
     * Add new model to models array.
     */
    addControllerModel(option) {
        var _a;
        if (!option)
            return;
        let controller = (_a = this.system.controller) === null || _a === void 0 ? void 0 : _a.component;
        let manufacturerId = controller === null || controller === void 0 ? void 0 : controller.manufacturerId;
        let match = this.models.filter(item => item.modelId == 0)[0];
        if (match) {
            match.modelName = option;
            match.manufacturerId = manufacturerId;
            return;
        }
        let model = new Model();
        model.modelId = 0;
        model.manufacturerId = manufacturerId;
        model.componentTypeId = ComponentTypeEnum.Controller;
        model.modelName = option;
        this.models.push(model);
        this.controllerModel = model;
    }
    ;
    deleteControllerModel(model) {
        this.$confirmModal.show(`Are you sure you want to remove the model ${model.modelName}`, { title: "Please Confirm" })
            .then((value) => {
            if (!value)
                return;
            // If it is a recently model added, just remove from the list
            if (model.modelId == 0) {
                this.models = this.models.filter(x => x.modelId != model.modelId);
                Notifier.onOk('Model removed from the list!');
                return;
            }
            modelClient
                .delete(model.modelId)
                .then(response => {
                if (response) {
                    this.models = this.models.filter(x => x.modelId != model.modelId);
                    Notifier.onOk('Model removed from the list!');
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            });
        });
    }
    addStringModel(manufacturerId, option, setModel) {
        if (!option)
            return;
        //let controller = this.system.controller?.component;
        //let manufacturerId = controller?.manufacturerId;
        let match = this.models.filter(item => item.modelId == 0)[0];
        if (match) {
            match.modelName = option;
            setModel(match);
            return;
        }
        let model = new Model();
        model.modelId = 0;
        model.manufacturerId = manufacturerId;
        model.componentTypeId = ComponentTypeEnum.String;
        model.modelName = option;
        this.models.push(model);
        if (setModel)
            setModel(model);
    }
    ;
    reloadManufacturerAndModel() {
        this.getManufacturersAndModels();
    }
    ;
    onAttachmentsChanged(attachments) {
        this.systemAttachmentsList = attachments || [];
    }
    onSerialNumberChanged() {
        this.serialNumberMsg.clear();
    }
    ;
    downloadRegistrationKeyFile(model) {
        var _a;
        if (!((_a = model === null || model === void 0 ? void 0 : model.registrationKey) === null || _a === void 0 ? void 0 : _a.authCode))
            throw new Error(`Invalid replacement code had been returned by data collection API`);
        model.registrationKey.whenCreated;
        // todo: might need to generate the file server side.
        let blob = new Blob([`${model.registrationKey.authCode}`], { type: 'text/plain;charset=utf-8' });
        let name = `${this.system.systemId}-${this.system.systemName}`.replace(/[^a-z0-9]/gi, '-').toLowerCase();
        let timestamp = DateHelper.getTimestampFromTime(model.registrationKey.whenCreated);
        let fileName = `monitor.replacement-${name}.${timestamp}.txt`;
        DownloadUtil.downloadFile(blob, fileName);
        Notifier.onOk(`Replacement key has been created. Please check your downloads folder.`);
    }
    ;
    // computed
    get pageTitle() {
        return this.isNewSystem ? "New System" : this.systemTitle;
    }
    ;
    get systemTitle() {
        if (!this.system)
            return "";
        return TextHelper.getRecordTitle(this.system.systemName || "", this.isSystemArchived);
    }
    ;
    get isNewSystem() {
        return !this.systemId;
    }
    ;
    get isSystemArchived() {
        return this.system.whenDeleted != null;
    }
    ;
    get isClientAdministrator() {
        return this.loginState.isClientAdministrator || this.loginState.isClientInstaller;
    }
    ;
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    get isClientInstaller() {
        return this.loginState.isClientInstaller;
    }
    ;
    get isKeyFieldDisabled() {
        return !this.isNewSystem || !this.isClientInstaller;
    }
    get companyId() {
        return this.system.companyId;
    }
    ;
    get company() {
        return this.companies.filter(item => {
            return (item.value == this.system.companyId);
        })[0] || null;
    }
    ;
    set company(item) {
        if (!item)
            return;
        this.system.companyId = item.value;
    }
    ;
    get upsManufacturer() {
        return this.chargerUpsManufacturers.filter(item => {
            return (item.value == this.system.manufacturerId);
        })[0] || null;
    }
    ;
    set upsManufacturer(item) {
        if (!item)
            return;
        this.system.manufacturerId = item.value;
    }
    ;
    get siteId() {
        return this.system.siteId;
    }
    ;
    get site() {
        return this.sites.filter(item => {
            return item.value == this.system.siteId;
        })[0] || null;
    }
    ;
    set site(item) {
        if (!item)
            return;
        this.system.siteId = item.value;
    }
    ;
    get systemCategory() {
        return this.systemCategories.filter(item => {
            return item.value == this.system.systemCategoryId;
        })[0] || null;
    }
    ;
    set systemCategory(item) {
        if (!item)
            return;
        this.system.systemCategoryId = item.value;
    }
    ;
    get batteryTypeId() {
        return this.system.batteryTypeId;
    }
    ;
    get batteryType() {
        return this.batteryTypes.filter(item => {
            return item.value == this.system.batteryTypeId;
        })[0] || null;
    }
    ;
    set batteryType(item) {
        if (!item)
            return;
        this.system.batteryTypeId = item.value;
    }
    ;
    get lithiumBatteryType() {
        return this.lithiumBatteryTypes.filter(item => {
            return item.value == this.system.lithiumBatteryTypeId;
        })[0] || this.lithiumBatteryTypes[0];
    }
    ;
    set lithiumBatteryType(item) {
        if (!item)
            return;
        this.system.lithiumBatteryTypeId = item.value;
    }
    ;
    get siteSelected() {
        return this.site && this.site.value;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get controllerModel() {
        return this.models.filter(item => { var _a, _b; return item.modelId == ((_b = (_a = this.system.controller) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.modelId); })[0] || null;
    }
    ;
    set controllerModel(item) {
        var _a, _b;
        if (!item)
            return;
        if (!((_b = (_a = this.system) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.component))
            return;
        this.system.controller.component.modelId = item.modelId;
    }
    ;
    /**
     * Address details for selected site.
     **/
    get siteAddress() {
        let site = this.siteOptions.filter(site => site.siteId == this.siteId)[0];
        if (!site)
            return null;
        if (!site.address)
            return null;
        return site.address;
    }
    ;
    get addressString() {
        let siteAddress = this.siteAddress;
        if (!siteAddress)
            return "";
        let parts = [siteAddress.streetAddress1, siteAddress.streetAddress3, siteAddress.countryName];
        return parts.filter(part => part).join(", ");
    }
    ;
    get hasController() {
        var _a;
        return ((_a = this.system.controller) === null || _a === void 0 ? void 0 : _a.component) != null;
    }
    ;
    get hasReplacementKey() {
        var _a, _b;
        return ((_b = (_a = this.system) === null || _a === void 0 ? void 0 : _a.controller) === null || _b === void 0 ? void 0 : _b.replacementRegistrationKey) ? true : false;
    }
    ;
    get serialNumber() {
        var _a, _b;
        return ((_b = (_a = this.system.controller) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.serialNumber) || "";
    }
    ;
    get canChangeCompany() {
        if (this.isClientAdministrator)
            return true;
        if (this.isClientInstaller)
            return this.isNewSystem || !this.system.companyId;
        return false;
    }
    ;
    get controllerModels() {
        var _a, _b, _c, _d;
        let modelId = (_b = (_a = this.system.controller) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.modelId;
        let manufacturerId = (_d = (_c = this.system.controller) === null || _c === void 0 ? void 0 : _c.component) === null || _d === void 0 ? void 0 : _d.manufacturerId;
        return this.models.filter(model => model.modelId == modelId
            || (model.componentTypeId == ComponentTypeEnum.Controller && (model.manufacturerId == null || model.manufacturerId == manufacturerId)));
    }
    ;
    get chargerUpsManufacturers() {
        return [{ value: null, text: TextHelper.emptyListItemName }].concat((this.manufacturers || [])
            .filter(item => item.manufacturerTypeId == ManufacturerTypeEnum.ChargerUPS)
            .map((item) => {
            return {
                value: item.manufacturerId,
                text: item.manufacturerName || ""
            };
        }));
    }
    ;
    get upsModel() {
        return this.models.filter(item => item.modelId == this.system.modelId &&
            (item.manufacturerId == this.system.manufacturerId))[0] || null;
    }
    ;
    set upsModel(item) {
        if (!item) {
            this.system.modelId = null;
            return;
        }
        this.system.modelId = item.modelId;
    }
    ;
    get chargerUpsModels() {
        let manufacturerId = this.system.manufacturerId;
        return this.models
            .filter(model => model.manufacturerId == manufacturerId);
    }
    ;
    get isStandardOrHigher() {
        return store.getters["licenseModule/isStandardOrHigher"];
    }
    get isCloud() {
        return store.getters["licenseModule/isCloud"];
    }
    /**
     * Hashes of the tabs that are actually rendered, in the same order as in the template.
     * Used to translate the b-tabs active index (which is based on rendered tabs) to a hash.
     */
    get visibleTabs() {
        const tabs = ["#details"];
        if (!this.isNewSystem && this.isPowerShield)
            tabs.push("#componentDetails");
        if (!this.isNewSystem && this.isStandardOrHigher)
            tabs.push("#management");
        if (!this.isNewSystem)
            tabs.push("#attachments");
        return tabs;
    }
    rememberSelectedTab() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentHash = this.visibleTabs[this.activeTab];
            if (!currentHash)
                return;
            history.replaceState(history.state, "", currentHash);
            this.$router.replace({ hash: currentHash });
            // Lazy load attachments when tab is activated
            yield this.$nextTick();
            if (currentHash === "#attachments" && this.systemAttachments) {
                this.systemAttachments.load();
            }
        });
    }
    ;
    requestReplacementKeyFileVisible() {
        var _a;
        return this.isClientInstaller && this.hasSerialNumber && !this.isNewSystem && ((_a = this.system) === null || _a === void 0 ? void 0 : _a.controllerKeepAlive);
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], SystemV2Vue.prototype, "loginState", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], SystemV2Vue.prototype, "systemManagement", void 0);
__decorate([
    Ref(),
    __metadata("design:type", typeof (_b = typeof SystemAttachmentsVue !== "undefined" && SystemAttachmentsVue) === "function" ? _b : Object)
], SystemV2Vue.prototype, "systemAttachments", void 0);
__decorate([
    Watch("system.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemV2Vue.prototype, "getCompanyLookups", null);
__decorate([
    Watch("upsManufacturer"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], SystemV2Vue.prototype, "onUpsManufacturerChanged", null);
__decorate([
    Watch("serialNumber"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemV2Vue.prototype, "onSerialNumberChanged", null);
__decorate([
    Watch("activeTab"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SystemV2Vue.prototype, "rememberSelectedTab", null);
SystemV2Vue = __decorate([
    Component({
        name: "SystemVue",
        components: {
            SystemConfigurationVue,
            SystemManagementVue,
            SystemAttachmentsVue
        },
        setup() {
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setFieldValue, setValues } = useForm({
                validationSchema: yup.object({
                    systemName: yup.string().trim().required(),
                    companyId: yup.object().listOptionRequired(),
                    siteId: yup.object().listOptionRequired(),
                    batteryTypeId: yup.object().listOptionRequired(),
                    systemOfflineTimeout: yup.number().max(999).min(0)
                })
            });
            const systemNameVal = defineInputBinds('systemName');
            const companyIdVal = defineComponentBinds('companyId');
            const siteIdVal = defineComponentBinds('siteId');
            const batteryTypeIdVal = defineComponentBinds('batteryTypeId');
            const systemOfflineTimeoutVal = defineInputBinds('systemOfflineTimeout');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                setValues,
                systemNameVal,
                companyIdVal,
                siteIdVal,
                batteryTypeIdVal,
                systemOfflineTimeoutVal
            };
        }
    })
], SystemV2Vue);
export default SystemV2Vue;
